import * as React from 'react';
import { DevicePropsType } from '../../types';
const screenshotUrl = require( './screenshot.jpg' );

const GutmannShowcasePhone : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <div><img src={ screenshotUrl } alt='Gutmann' /></div>
    );
  };

export default GutmannShowcasePhone;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/GutmannShowcasePhone/GutmannShowcasePhone.tsx